import type {SelectItem} from '@jetbrains/ring-ui/components/select/select'
import {sentenceCase} from 'change-case'
import React, {useCallback} from 'react'

import SidebarSelect from '../../../../SidebarSelect/SidebarSelect'
import {generatedFields} from '../JobStepHotFields/JobStepHotFields.descriptors'

import styles from './StepTypeSelect.css'

type Props = {
  selectedType: string | null | undefined
  onChange: (type: string) => void
  updated?: boolean
}

const data: ReadonlyArray<SelectItem> = Object.keys(generatedFields).map(key => ({
  key,
  label: sentenceCase(key),
}))

function StepTypeSelect({selectedType, onChange}: Props) {
  const selected = data.find(i => i.key === selectedType)

  const onSelectChange = useCallback(
    (value: SelectItem | null) => {
      if (value != null) {
        onChange(String(value.key))
      }
    },
    [onChange],
  )

  return (
    <>
      <SidebarSelect
        containerClassName={styles.container}
        data={data}
        selected={selected}
        onChange={onSelectChange}
      />
    </>
  )
}

export default StepTypeSelect
